<app-page-header title="Metodversionsdetaljer" icon="bookmarks"></app-page-header>
<div [@fadeInOut] class="page-content">
  <mat-tab-group>
    <mat-tab label="Allmänt">
      <form #form="ngForm" [formGroup]="methodVersionForm" (ngSubmit)="save()" novalidate class="flex-col gap-1em" autocomplete="off">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Namn</mat-label>
                <input matInput formControlName="name"class="flex-row flex-col-ltmd gap-col-1em" required />
                @if (getFormControl('name').hasError('required')) {
                  <mat-error>Namn är obligatoriskt</mat-error>
                }
                @if (getFormControl('name').hasError('maxlength')) {
                  <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
                }
              </mat-form-field>
              <div class="flex-1">
                <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
              </div>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Verksamhetskategori</mat-label>
                <mat-select formControlName="businessCategoryId"class="flex-row flex-col-ltmd gap-col-1em" required [disabled]="!isNew">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of businessCategories$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('businessCategoryId').hasError('required')) {
                  <mat-error>Verksamhetskategori är obligatorisk</mat-error>
                }
              </mat-form-field>
              <div class="flex-1">
                <mat-checkbox formControlName="preview">Preliminär</mat-checkbox>
              </div>
            </div>

            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Mall för utskrift</mat-label>
                <mat-select formControlName="reportOutputTemplateId"class="flex-row flex-col-ltmd gap-col-1em" required>
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of reportOutputTemplates$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('reportOutputTemplateId').hasError('required')) {
                  <mat-error>Mall för utskrift är obligatorisk</mat-error>
                }
              </mat-form-field>
              <div class="flex-1">
                <mat-checkbox formControlName="includeRequirements">Inkludera minimikrav</mat-checkbox>
              </div>
            </div>

            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Skapad av</mat-label>
                  <input matInput value="{{ createdByName$ | async }}"class="flex-row flex-col-ltmd gap-col-1em" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Skapad</mat-label>
                  <input matInput formControlName="createdDate"class="flex-row flex-col-ltmd gap-col-1em" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad av</mat-label>
                  <input matInput value="{{ changedByName$ | async }}"class="flex-row flex-col-ltmd gap-col-1em" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad</mat-label>
                  <input matInput formControlName="updatedDate"class="flex-row flex-col-ltmd gap-col-1em" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Id</mat-label>
                  <input matInput formControlName="methodVersionId"class="flex-row flex-col-ltmd gap-col-1em" [readonly]="true" />
                </mat-form-field>
              </div>
            }
          </mat-card-content>
          <mat-card-actions>
            <section class="button-container">
              @if (hasPermissionToChange$ | async) {
                <button type="submit" mat-fab color="primary" matTooltip="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
              }
              <button type="button" mat-fab color="accent" title="{{'commands.Options' | translate }}" [matMenuTriggerFor]="optionsMenu"><mat-icon>menu</mat-icon></button>
              <mat-menu #optionsMenu="matMenu">
                <button type="button" mat-menu-item (click)="cancel()"><mat-icon>arrow_back</mat-icon><span>{{'commands.Cancel' | translate }}</span></button>
                <button type="button" mat-menu-item [disabled]="isNew" (click)="createTestReport()"><mat-icon>description</mat-icon><span>Skapa testrapport</span></button>
                <button type="button" mat-menu-item [disabled]="isNew" (click)="rebuild()"><mat-icon>build</mat-icon><span>Uppdatera definitionen</span></button>
                <button type="button" mat-menu-item [disabled]="isNew" (click)="refresh()"><mat-icon>autorenew</mat-icon><span>Uppdatera texter</span></button>
                <button type="button" mat-menu-item [disabled]="isNew || methodVersionIsActive()" (click)="activate()"><mat-icon>lock</mat-icon><span>Aktivera</span></button>
                <button type="button" mat-menu-item [disabled]="!hasPermissionToDelete() || isNew" (click)="delete()"><mat-icon>delete</mat-icon><span>{{'commands.Delete' | translate }}</span></button>
              </mat-menu>
            </section>
          </mat-card-actions>
        </mat-card>
      </form>
    </mat-tab>
    @if (!isNew) {
      <mat-tab label="Rapporter">
        <app-report-list [methodVersionId]="id" [showTitle]="false"></app-report-list>
      </mat-tab>
    }
  </mat-tab-group>

</div>
